import {FormControl, FormField} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetSupplierDiscountGroupsQuery, useGetWarehouseQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {MaterialDiscountFormType} from '../types/materialDiscountFormSchema';

interface DiscountGroupSelectProps extends TestIdProps {
  control: FormControl<MaterialDiscountFormType>;
  warehouseId?: string;
}

export function DiscountGroupSelect(props: DiscountGroupSelectProps) {
  const warehouseQuery = useGetWarehouseQuery(
    {warehouseId: props.warehouseId as string},
    {skip: isNilOrEmpty(props.warehouseId)}
  );

  const {supplierDiscountGroupsOptions, isLoadingSupplierDiscountGroups} =
    useGetSupplierDiscountGroupsQuery(
      {
        supplierId: warehouseQuery.data?.defaultSupplierId as string,
        authorizationProfileId: warehouseQuery.data?.authorizationProfileId as string,
      },
      {
        skip:
          isNilOrEmpty(warehouseQuery.data?.defaultSupplierId) ||
          isNilOrEmpty(warehouseQuery.data?.authorizationProfileId),
        selectFromResult: (result) => ({
          isLoadingSupplierDiscountGroups: result.isLoading,
          supplierDiscountGroupsOptions: isNilOrEmpty(props.warehouseId)
            ? []
            : (result.data?.discountGroupCode?.map((supplierDiscountGroup) => ({
                label: supplierDiscountGroup?.code,
                value: supplierDiscountGroup?.discountGroupId,
              })) ?? []),
        }),
      }
    );

  const isLoading = warehouseQuery.isLoading || isLoadingSupplierDiscountGroups;

  return (
    <FormField
      isNotClearable
      isLoading={isLoading}
      control={props.control}
      type="multiChoice"
      name="supplierDiscountGroupId"
      options={supplierDiscountGroupsOptions}
      label={i18n.t('entity.workshopCustomerGroup.labels.rabatGroup')}
      data-testid={props['data-testid']}
      menuInPortal
    />
  );
}
